(function (angular, schoolwork12) {
    'use strict';

    schoolwork12.app.common = {
        name: 'schoolwork12.common',
        services: {
            eventNotification: 'eventNotification',
            storage: 'storage',
            utilService: 'utilService'
        }
    };

    angular.module(schoolwork12.app.common.name, []);
}(angular, schoolwork12));
